module.exports = KsysAppTemplateV2dot35dot0;